import { cn } from "@omni/utils/styles";
import { sumBy } from "lodash-es";

import { NumberOfHitsConfigurationEntry } from "@/components/Search/SearchResults/StateComponents/NumberOfHits/numberOfHits.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { NumberOfHitsState } from "@/utils/search/types/searchState";

type NumberOfHitsComponentProps = {
    configuration: Array<NumberOfHitsConfigurationEntry>;
    numberOfHitsComponentsState: Array<NumberOfHitsState | undefined>;
};

const NumberOfHitsComponent = ({
    configuration,
    numberOfHitsComponentsState
}: NumberOfHitsComponentProps) => {
    const { t } = useGranite();

    const totalNumberOfHits = sumBy(
        numberOfHitsComponentsState,
        (numberOfHitsComponentState) =>
            numberOfHitsComponentState?.numberOfHits ?? 0
    );

    if (!totalNumberOfHits) return null;

    const toNumberOfHitsEntry = (
        configurationEntry: NumberOfHitsConfigurationEntry
    ) => {
        const numberOfHits = numberOfHitsComponentsState.find(
            (componentState) =>
                componentState?.component === configurationEntry.component
        )?.numberOfHits;

        if (!numberOfHits) return;

        return `<a href="#${
            configurationEntry.resultListId
        }" class="${cn("tw:underline tw:cursor-pointer tw:text-grey-dark")}">${numberOfHits}&nbsp;${t(
            configurationEntry.translationKey
        ).replaceAll(" ", "&nbsp;")}</a>`;
    };

    const numberOfHitsEntries = configuration
        .map(toNumberOfHitsEntry)
        .filter((hitStat) => hitStat !== undefined);

    if (numberOfHitsEntries.length === 0) return null;

    const joinedNumberOfHits =
        numberOfHitsEntries.length > 1
            ? numberOfHitsEntries.slice(0, -1).join(", ") +
              " " +
              t("search.summary.stats.finalResult", numberOfHitsEntries.at(-1))
            : numberOfHitsEntries.at(0);

    return (
        <p
            className={cn("tw:mt-2 tw:mb-4")}
            dangerouslySetInnerHTML={{
                __html: t("search.summary.stats", joinedNumberOfHits)
            }}
        ></p>
    );
};

export { NumberOfHitsComponent };
